import { Box, Typography } from "@mui/material";
import PropTypes from "prop-types";
import { colorsFoundation } from "../tokens/colors-foundation.js";
import { dimensions } from "../tokens/dimensions.js";

/**
 * EmptyState — the centered empty placeholder from the click-dummy: a muted
 * icon, a title, an optional description line and an optional action. Use for
 * "no results" / "nothing here yet" states on pages and inside cards.
 */
export default function EmptyState({ icon, title, description, action, sx }) {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        gap: dimensions.md,
        py: dimensions["6xl"],
        px: dimensions.xl,
        ...sx,
      }}
    >
      {icon && (
        <Box
          sx={{
            color: colorsFoundation.gray[300],
            display: "flex",
            "& .MuiSvgIcon-root": { fontSize: "40px" },
          }}
        >
          {icon}
        </Box>
      )}
      {title && (
        <Typography
          sx={{
            fontSize: "0.9375rem",
            fontWeight: 600,
            color: colorsFoundation.gray[700],
          }}
        >
          {title}
        </Typography>
      )}
      {description && (
        <Typography
          sx={{ fontSize: "0.8125rem", color: colorsFoundation.gray[500] }}
        >
          {description}
        </Typography>
      )}
      {action && <Box sx={{ mt: dimensions.sm }}>{action}</Box>}
    </Box>
  );
}

EmptyState.propTypes = {
  icon: PropTypes.node,
  title: PropTypes.node,
  description: PropTypes.node,
  action: PropTypes.node,
  sx: PropTypes.object,
};
